import { Spacing } from '@persona-id/design-tokens';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import Button from 'design-system/components/Button';

export const ToggleButtonContainer = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.element.borderRadius};
  background-color: ${({ theme }) => theme.color.background.secondary};
  padding: ${Spacing[1]};
  display: flex;
  align-items: center;
  gap: ${Spacing[2]};
  margin-bottom: ${Spacing[4]};
`;

export const StyledToggleButton = styled(Button).attrs<{ isActive: boolean }>((props) => ({
  variant: 'basic',
  disabled: props.isActive,
  style: {
    backgroundColor: props.isActive ? props.theme.color.background.primary : null,
  },
}))<{ isActive: boolean }>``;

interface ToggleButtonProps {
  inactiveButtonLabel: string;
  activeButtonLabel: string;
  isActive: boolean;
  setIsActive: Dispatch<SetStateAction<boolean>>;
}

export default function ToggleButton({
  activeButtonLabel,
  inactiveButtonLabel,
  isActive,
  setIsActive,
}: ToggleButtonProps) {
  return (
    <ToggleButtonContainer>
      <StyledToggleButton
        onClick={() => {
          setIsActive(false);
        }}
        id='toggle-button__enable-inactive-state-button'
        isActive={!isActive}
      >
        {inactiveButtonLabel}
      </StyledToggleButton>
      <StyledToggleButton
        onClick={() => {
          setIsActive(true);
        }}
        id='toggle-button__enable-active-state-button'
        isActive={isActive}
      >
        {activeButtonLabel}
      </StyledToggleButton>
    </ToggleButtonContainer>
  );
}
